module.exports = __webpack_public_path__ + "img/05ba5c9.png";